import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateQuantityUnitForm from '../../forms/CreateOrUpdateQuantityUnitForm'

interface CreateQuantityUnitModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateQuantityUnitModal: React.FC<CreateQuantityUnitModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => (
  <AppModal open={open} onClose={onClose} title="Add Quantity Unit" width="sm" loading={loading}>
    <CreateOrUpdateQuantityUnitForm loading={loading} error={error} />
  </AppModal>
)

export default CreateQuantityUnitModal
